import React, { useEffect, useState } from "react";
import {
  FaBuilding,
  FaUser,
  FaFileInvoiceDollar,
  FaHandshake,
} from "react-icons/fa";
import { AmountFormat } from "components/common/formatter";
import { getMattersBalances } from "services/postingsService";
import styles from "./MatterBalancesCard.module.scss";

const EMPTY_BALANCES = {};

const CHIPS = [
  {
    key: "officeBalance",
    label: "Office Bal",
    tone: "indigo",
    icon: <FaBuilding />,
  },
  { key: "clientBalance", label: "Client Bal", tone: "green", icon: <FaUser /> },
  { key: "duuBalance", label: "DUU", tone: "amber", badge: "DUU" },
  { key: "dpuBalance", label: "DPU", tone: "red", badge: "DPU" },
  { key: "dubBalance", label: "DUB", tone: "blue", badge: "DUB" },
  {
    key: "unpaidBills",
    label: "Unpaid Bills",
    tone: "pink",
    icon: <FaFileInvoiceDollar />,
  },
  { key: "ddaBalance", label: "DDA", tone: "red", badge: "DDA" },
  { key: "wipBalance", label: "WIP", tone: "green", badge: "WIP" },
  {
    key: "undertakingBalance",
    label: "Undertaking",
    tone: "purple",
    icon: <FaHandshake />,
  },
];

const displayValue = (value) => {
  const formatted = AmountFormat(value);
  return formatted === "" ? "—" : formatted;
};

const MatterBalancesCard = ({ matterId, className = "" }) => {
  const [balances, setBalances] = useState(EMPTY_BALANCES);

  useEffect(() => {
    if (!matterId) {
      setBalances(EMPTY_BALANCES);
      return;
    }
    let cancelled = false;
    (async () => {
      try {
        const res = await getMattersBalances(matterId);
        if (!cancelled) setBalances(res?.matterBalances ?? EMPTY_BALANCES);
      } catch (err) {
        console.error("Failed to fetch matter balances", err);
        if (!cancelled) setBalances(EMPTY_BALANCES);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [matterId]);

  return (
    <div className={`${styles.card} ${className}`}>
      {CHIPS.map((chip) => (
        <div key={chip.key} className={styles.chip}>
          <span
            className={`${styles.badge} ${styles[chip.tone]}`}
            aria-hidden="true">
            {chip.badge ? (
              <span className={styles.badgeText}>{chip.badge}</span>
            ) : (
              chip.icon
            )}
          </span>
          <span className={styles.meta}>
            <span className={styles.label}>{chip.label}:</span>
            <span className={styles.value}>
              {displayValue(balances?.[chip.key])}
            </span>
          </span>
        </div>
      ))}
    </div>
  );
};

export default MatterBalancesCard;
